import { render, staticRenderFns } from "./patientImportTemplate.vue?vue&type=template&id=6b8a72d6&scoped=true&"
import script from "./patientImportTemplate.vue?vue&type=script&lang=js&"
export * from "./patientImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./patientImportTemplate.vue?vue&type=style&index=0&id=6b8a72d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a72d6",
  null
  
)

export default component.exports